import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import invoke from 'lodash.invoke';
import Button from './Button';
import { uniqueIdForComponent, getOtherProps } from '../util';
import RenderInBody from './RenderInBody';
var propTypes = {
  /**
   * Description of the dialog.
   * The description will not be visible to the end users but will be used by accessibility tools
   * such as screen readers.
   */
  ariaLabel: PropTypes.string,

  /**  title of the dialog */
  title: PropTypes.string,

  /**  onClick event of the action button */
  onActionButtonClick: PropTypes.func,

  /**  function to validate form data in the dialog */
  validate: PropTypes.func,

  /**  on close dialog event */
  onClose: PropTypes.func,

  /**  indicates if the dialog is open */
  open: PropTypes.bool,

  /** setting to true will show a dialog without padding */
  full: PropTypes.bool,

  /** indicates the button which should trigger the primary action */
  primaryButton: PropTypes.shape({
    type: PropTypes.oneOf([Button])
  }),

  /** indicates the button which should trigger the secondary action */
  secondaryButton: PropTypes.shape({
    type: PropTypes.oneOf([Button])
  }),

  /** forces user interation with the dialog to close it */
  blocking: PropTypes.bool,

  /**  node is a form element */
  children: PropTypes.node,

  /** id of the dialog */
  id: PropTypes.string
};
var defaultProps = {
  title: undefined,
  ariaLabel: undefined,
  onActionButtonClick: function onActionButtonClick() {},
  validate: undefined,
  onClose: function onClose() {},
  open: false,
  children: undefined,
  full: false,
  primaryButton: undefined,
  secondaryButton: undefined,
  blocking: false,
  id: ''
};

var Dialog = /*#__PURE__*/function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog(props) {
    var _this;

    _classCallCheck(this, Dialog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dialog).call(this, props));
    _this.state = {
      id: props.id || uniqueIdForComponent(_assertThisInitialized(_this)),
      open: props.open,
      dialogTitleId: uniqueIdForComponent(_assertThisInitialized(_this)),
      dialogBodyId: uniqueIdForComponent(_assertThisInitialized(_this))
    };
    _this.handleActionRequest = _this.handleActionRequest.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.handleDialogOnOpen = _this.handleDialogOnOpen.bind(_assertThisInitialized(_this));
    _this.handleDialogOnClose = _this.handleDialogOnClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Dialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invoke(window.govhhswds, 'dialog.init', document);
      this.removeEventListeners();
      this.addEventListeners();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      document.addEventListener('dialog.onOpen', this.handleDialogOnOpen); // eslint-disable-line

      document.addEventListener('dialog.onClose', this.handleDialogOnClose); // eslint-disable-line
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      document.removeEventListener('dialog.onOpen', this.handleDialogOnOpen);
      document.removeEventListener('dialog.onClose', this.handleDialogOnClose);
    }
  }, {
    key: "handleDialogOnOpen",
    value: function handleDialogOnOpen(event) {
      var id = this.state.id;

      if (event.detail && event.detail.dialogId && event.detail.dialogId === id) {
        this.setState({
          open: true
        });
      }
    }
  }, {
    key: "handleDialogOnClose",
    value: function handleDialogOnClose(event) {
      var id = this.state.id;

      if (event.detail && event.detail.dialogId && event.detail.dialogId === id) {
        this.setState({
          open: false
        });
        this.handleClose();
      }
    }
  }, {
    key: "handleActionRequest",
    value: function handleActionRequest() {
      var _this2 = this;

      var _this$props = this.props,
          validate = _this$props.validate,
          onActionButtonClick = _this$props.onActionButtonClick;

      var closeDialog = function closeDialog() {
        invoke(window.govhhswds, 'dialog.close', document);

        _this2.setState({
          open: false
        });
      };

      if (validate && typeof validate === 'function') {
        if (validate()) {
          onActionButtonClick();
          closeDialog();
        }
      } else {
        onActionButtonClick();
        closeDialog();
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.props.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var otherProps = getOtherProps(Dialog.propTypes, this.props);
      var _this$state = this.state,
          id = _this$state.id,
          open = _this$state.open;
      return (
        /* eslint-disable react/prop-types */
        React.createElement(RenderInBody, {
          key: "render-in-body-".concat(id)
        }, React.createElement("div", _extends({
          className: classNames('wds-c-dialog-container', {
            'wds-u-hidden': !open
          }),
          "aria-labelledby": "".concat(id, "-description"),
          "aria-hidden": !open
        }, otherProps), this.props.ariaLabel && React.createElement("div", {
          id: "".concat(id, "-description"),
          className: "wds-u-sr-only"
        }, this.props.ariaLabel), React.createElement("div", {
          className: classNames('wds-c-dialog', {
            'wds-c-dialog--blocking': this.props.blocking,
            'wds-u-p--none': this.props.full
          }),
          "data-modal-id": id,
          "aria-labelledby": this.state.dialogTitleId,
          "aria-describedby": "".concat(id, "-description ").concat(this.state.dialogBodyId),
          role: this.props.blocking ? 'alertdialog' : 'dialog',
          "aria-modal": "true",
          id: id
        }, this.props.title && React.createElement("div", {
          className: "wds-c-dialog__header"
        }, React.createElement("h2", {
          id: this.state.dialogTitleId
        }, this.props.title)), !this.props.full ? React.createElement("div", {
          id: this.state.dialogBodyId,
          className: "wds-c-dialog__body"
        }, open && this.props.children) : React.createElement("div", {
          id: this.state.dialogBodyId
        }, open && this.props.children), React.createElement("div", {
          className: "wds-c-dialog__footer"
        }, this.props.secondaryButton ? React.cloneElement(this.props.secondaryButton, {
          onClick: function onClick(event) {
            if (typeof _this3.props.secondaryButton.props.onClick === 'function') {
              _this3.props.secondaryButton.props.onClick(event);
            }
          },
          'data-modal-close': true
        }) : null, this.props.primaryButton ? React.cloneElement(this.props.primaryButton, {
          onClick: this.handleActionRequest,
          'data-modal-close': typeof this.props.validate !== 'function'
        }) : null))))
      );
    }
  }]);

  return Dialog;
}(Component);

Dialog.propTypes = propTypes;
Dialog.defaultProps = defaultProps;
export default Dialog;